import React, { FC, useCallback } from 'react'
import { InterceptContainer, InterceptSubTitle, InterceptTitle } from './intercept.styles'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { gridPosition } from '../../../utils/tracking/grid-position'
import { useTrackViewedInteraction } from '../../../hooks/tracking/useTrackViewedInteraction.hook'
import { Button } from '@at/design-system-elements'
import { trackComponentViewedOnce } from '../../../pages/search-results/results-scrolling-observer'
import { useInterceptContent } from './use-intercept.hook'
import { InterceptType } from '../../../__generated__/fed-graphql-types'

interface InterceptProps {
    interceptType: InterceptType
    title?: string | null
    subtitle?: string | null
    buttonText?: string | null
    sort?: string | null
    ctaUrl?: string | null
    position: number
}

export const Intercept: FC<InterceptProps> = ({
    interceptType,
    title,
    subtitle,
    buttonText,
    ctaUrl,
    position,
    sort = 'relevance',
}: InterceptProps) => {
    const { pictogram, trackingLabel, componentNameLabel, handleClick } = useInterceptContent(
        interceptType,
        position,
        sort
    )

    const trackingButtonInteraction = useATTrackInteraction({
        trackingLabel,
    })
    const positionEntity = gridPosition({ row: position, col: 1 })
    const trackInteraction = useTrackViewedInteraction(componentNameLabel)
    const trackingElementRef = useCallback(
        (trackingElementRef: HTMLDivElement) => {
            trackComponentViewedOnce(trackingElementRef, trackInteraction, componentNameLabel, positionEntity)
        },
        [trackInteraction, componentNameLabel, positionEntity]
    )

    return (
        <InterceptContainer ref={trackingElementRef}>
            {pictogram}
            <InterceptTitle>{title}</InterceptTitle>
            <InterceptSubTitle>{subtitle}</InterceptSubTitle>
            <Button
                displayType="secondary"
                text={buttonText ?? ''}
                url={ctaUrl ?? undefined}
                onClick={handleClick}
                trackingCallback={trackingButtonInteraction}
            />
        </InterceptContainer>
    )
}
